import { Listing } from "@cma/chat-widgets/find-listings-search/types/Listing";
import { SinglePropertyResponse } from "@shared/apis/sidekick/generated";
import { buildListingMlsKey } from "@cma/shared/helpers/listing-mls-key";

export const convertSinglePropertyToListing = (
  property: SinglePropertyResponse,
): Listing => {
  return {
    id: buildListingMlsKey({
      mlsId: property.mlsId,
      mlsSource: property.mlsSource,
    }),
    addressLine1: property.addressLine1,
    addressLine2: property.addressLine2 || undefined,
    city: property.city,
    state: property.state,
    neighborhood: property.neighborhood,
    zipCode: property.zipCode,
    bedroomCount: property.bedroomCount,
    numBedrooms: property.bedroomCount, // Duplicate field for backward compatibility
    bathroomCount: property.bathroomCount,
    numBathrooms: property.bathroomCount, // Duplicate field for backward compatibility
    currentPrice: property.currentPrice,
    internalSize: property.internalSize,
    costPerInternalSqFt: property.costPerInternalSqFt,
    lotSize: property.lotSize,
    listDate: property.listDate ? property.listDate.toISOString() : "",
    hoaMonthlyFee: property.hoaMonthlyFee,
    propertyType: {
      id: property.propertyType?.id ?? 0,
      propertyType: property.propertyType?.propertyType ?? "Unknown",
    },
    listingStatus: {
      id: property.listingStatus?.id ?? 0, // Default to 0 if undefined
      listingStatus: property.listingStatus?.listingStatus ?? "Unknown",
    },
    lastSourceUpdateDate: property.lastSourceUpdateDate.toISOString(),
    soldPrice: property.soldPrice,
    listPrice: property.listPrice,
    hasDoormanAttendance: property.hasDoormanAttendance,
    isLease: property.isLease,
    photos: property.photos ?? [],
    uPropertyId: property.uPropertyId ? String(property.uPropertyId) : "",
    yearBuilt: property.yearBuilt,
    link: property.link,
    description: property.description || undefined,
    agents: property.agents
      ? property.agents.map((agent) => ({
          name: agent.name,
          brokerage: agent.brokerage,
          lastSourceUpdateDate: agent.lastSourceUpdateDate
            ? agent.lastSourceUpdateDate.toISOString()
            : null,
        }))
      : undefined,
    unitCount: property.unitCount || undefined,
    latitude: property.latitude || undefined,
    longitude: property.longitude || undefined,
    mlsId: property.mlsId,
    mlsSource: property.mlsSource,
    county: property.county || undefined,
    parkingGarageSpaces: property.parkingGarageSpaces || undefined,
  };
};
